import { mapGetters } from 'vuex'
import { checkPhone } from '@/utils/validate-rules'
import { checkPorscheEmail } from '../valid'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['currentAccount']),
  },

  created() {
    const account =
      this.currentAccount ||
      (this.fromGuest ? this.$route.query.gi_address : '')
    this.initAccount(account)
  },

  methods: {
    back() {
      this.$router.replace({
        path: '/cim',
        query: {
          ...this.$route.query,
        },
      })
    },
    forgotPassword() {
      let result = false
      if (this.type === 'phone') {
        result = checkPhone(this.form[this.type])
      } else if (this.type === 'email') {
        result = checkPorscheEmail(this.form[this.type])
      }

      if (result) {
        this.$store.commit('setCurrentAccount', this.form[this.type])
      }

      this.$router.replace({
        path: '/cim/reset_password/email/account',
        query: { ...this.$route.query },
      })
    },
  },
}
